export const reduxGet = {
  dispatch: null,
  getState: null,
};

export const injectReduxStore = (_store) => {
  reduxGet.dispatch = _store?.dispatch;
  reduxGet.getState = _store?.getState;
};
